import apiRequest from '../apis/api-request';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const statusService = {

    getStatusHistory: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "POST",
            url: `/api/workstatus/history`,
            data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    todayWorkStatusCreate: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method:"POST",
            url: `/api/workstatus/today`,
            data,
            headers: {
                Authorization: "Bearer " + token
            }
        });
    },

};

export default statusService;